import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

/**
 * Floating quiz button that lives next to FloatingWhatsApp.
 * Positioned ABOVE WhatsApp (stacked vertical) so both are reachable on mobile.
 */
export const FloatingQuiz = () => {
    const { t } = useLanguage();
    return (
        <Link
            to="/quiz"
            aria-label={t.quizCta.cta}
            data-testid="floating-quiz-button"
            className="group fixed bottom-[148px] right-5 z-50 flex items-center gap-2 pl-3 pr-4 py-3 rounded-full bg-black text-fw border border-fw shadow-lg transition-all duration-300 hover:scale-105 hover:bg-fw hover:text-black"
            style={{ boxShadow: "0 4px 20px rgba(42, 189, 22, 0.35)" }}
        >
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-fw/20 group-hover:bg-black/10 transition-colors">
                <Compass className="h-4 w-4" strokeWidth={2.2} />
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.22em] font-semibold whitespace-nowrap">
                Quiz
            </span>
        </Link>
    );
};
